<template>
    <CButton
        :block="block"
        :color="color"
        :disabled="disabled"
        :type="type"
        class="ml-2 button shadow d-flex"
        @click="$emit('click')"
    >
        <span class="button__icon">
            <CIcon :content="$options.icons.cilSave"/>
        </span>
        <span class="button__text">
            <slot>
                {{ $t("save") }}
            </slot>
            
        </span>
    </CButton>
</template>

<script>
import { cilSave } from '@coreui/icons';
export default {
    name: "ButtonSave",
    icons:{
        cilSave
    },
    props: {
        block: {
            type: Boolean,
            default: false
        },
        color: {
            type: String,
            default: "success"
        },
        disabled: Boolean,
        type: String
    }

}
</script>
<style lang="scss">

</style>